import { render, staticRenderFns } from "./rcRecord.vue?vue&type=template&id=4c718f04&scoped=true"
import script from "./rcRecord.vue?vue&type=script&lang=js"
export * from "./rcRecord.vue?vue&type=script&lang=js"
import style0 from "./rcRecord.vue?vue&type=style&index=0&id=4c718f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c718f04",
  null
  
)

export default component.exports